import { render, staticRenderFns } from "./ModuleMenuList.vue?vue&type=template&id=765ef9ac&scoped=true"
import script from "./ModuleMenuList.vue?vue&type=script&lang=js"
export * from "./ModuleMenuList.vue?vue&type=script&lang=js"
import style0 from "./ModuleMenuList.vue?vue&type=style&index=0&id=765ef9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ef9ac",
  null
  
)

export default component.exports